<template>
  <body>
    <div class="wrapper">
      <Sidebar :alertNotif="countChat"></Sidebar>
      <div class="main-panel" id="main-panel">
        <Navbar></Navbar>
        <div class="panel-header panel-header-sm"></div>
        <template v-if="$route.path == '/dashboard'">
          <transition name="component-fade" mode="out-in">
            <div class="panel-header panel-header-lg" style="padding-top: 0px">
              <div
                v-if="user.totalProduct === 0"
                class="text-center"
                style="margin-top: -40px"
              >
                <img width="30%" class="mb-5 mt-5" />
                <h5 class="text-light">
                  The Dashboard Will Show Up once there is enough data
                </h5>
                <p class="text-secondary">Start selling your product</p>
                <router-link
                  v-if="user.inActive === true && user.isBlocked === false"
                  :to="'/product/addproduct'"
                  class="text-primary"
                >
                   Create a Product
                 </router-link>
              </div> 
              <BigChart v-else></BigChart>
            </div>
          </transition>
        </template>

        <div class="content">
          <div
            v-if="$route.path === '/pesanan' && user.isMustUpdate"
            class="row sticky-top"
          >
            <div class="alert alert-warning p-3 custom-block w-100" id="notif">
              <span>
                <i class="fa fa-paperclip" aria-hidden="true"> </i>
                <span class="ml-2" v-html="'Segera ' + user.alert.title"></span>
              </span>
            </div>
          </div>
          <transition name="component-fade" mode="out-in">
            <router-view :key="$route.path"></router-view>
          </transition>
        </div>
      </div>
      <a href="#" id="scroll" style="display: none"><span></span></a>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>
import Notification from "/src/components/ToastComponent/Notification.vue";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BigChart from "/src/ChartComponents/BigChart.vue";
import $ from "jquery";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      alertNotif: 0,
    };
  },
  name: "TheContainer",
  components: {
    Sidebar,
    Navbar,
    Footer,
    BigChart,
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
      countChat: "countChat",
    }),
  },
  mounted: function() {
    this.scrollToUp();
    // JIKA AKUN isMustUpdate
    this.alertMustUpdate();
    console.log(this.user);
  },

  watch: {
    countChat() {
      const contentToast = {
        component: Notification,
      };

      setTimeout(() => {
        this.countChat !== 0 ? this.$toast(contentToast) : "";
      }, 550);
    },
  },
  updated() {
    if (this.user.isMustUpdate) {
      if (this.user.isBlocked === false && this.user.inActive) {
        return false;
      } else {
        this.$router.push({ path: "/dashboard" });
      }

      if (this.user.isBlocked === false && this.user.inActive) {
        return false;
      } else {
        this.$swal
          .fire({
            title: this.user.alert.title,
            html: this.user.alert.message,
            showCancelButton: false,
            confirmButtonText: `Ok`,
            showDenyButton:
              this.user.isMustUpdate &&
              this.user.isBlocked === false &&
              this.user.inActive
                ? true
                : false,
            denyButtonText: `Produk`,
            denyButtonColor: "#aaa",
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.logout();
            } else if (result.isDenied) {
              this.$router.push({ path: "/product" });
            }
          });
      }
    }
  },
  created() {
    this.$store.dispatch("get_count_chat");
    this.alertNotif = this.countChat;
  },
  methods: {
    alertMustUpdate() {
      if (this.user.isMustUpdate) {
        // this.$router.push({ path: "/dashboard" });
        this.$swal
          .fire({
            title: `<span style="font-size:20px;">Info</span>`,
            html: `<span style="font-size:14px;">Anda memiliki ${this.user.totalNotifReminder} notifikasi yang perlu dibaca</span>`,
            icon: "info",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: `Oke`,
            confirmButtonColor: "#556ee6",
            showDenyButton: false,
            // showDenyButton:
            //   this.user.isMustUpdate &&
            //   this.user.isBlocked === false &&
            //   this.user.inActive
            //     ? true
            //     : false,
            denyButtonText: `Produk <i class="fa fa-arrow-alt-circle-right"></i>`,
            denyButtonColor: "#233142",
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (this.user.isBlocked === false && this.user.inActive) {
                this.$swal.close();
              } else {
                this.logout();
              }
            } else if (result.isDenied) {
              this.$router.push({ path: "/product" });
            }
          });
      }
    },
    scrollToUp() {
      $(document).ready(function() {
        $(window).scroll(function() {
          if ($(this).scrollTop() > 1331) {
            $("#scroll").fadeIn();
            $(".float-btn").fadeOut();
          } else {
            $("#scroll").fadeOut();
            $(".float-btn").fadeIn();
          }
        });
        $("#scroll").click(function() {
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            600
          );
          return false;
        });
      });
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("login");
      });
    },
    handleNetworkError() {
      if (typeof this.user.id === "undefined") {
        alert("NetworkError from container");
      }
    },
    toChat() {
      this.$router.push({
        path: "/chat",
      });
    },
  },
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-active {
  opacity: 0;
}

.float-btn {
  display: block;
  width: 45px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #f3f3f3;
  font-size: 15px;
  font-weight: bold;
  border-radius: 50%;
  text-decoration: none;
  position: fixed;
  right: 20px;
  bottom: 30px;
  margin: 0px 0px 20px 0px;
  background: linear-gradient(0deg, #2a3042 0%, #2a3042 100%);
}

.float-btn span {
  position: absolute;
  top: 48%;
  left: 50%;
  margin-left: -8px;
  margin-top: -12px;
  height: 0;
  width: 0;
  border: 8px solid transparent;
  border-bottom-color: #ffffff;
}

#scroll {
  position: fixed;
  right: 20px;
  bottom: 30px;
  margin: 0px 0px 20px 0px;
  cursor: pointer;
  width: 45px;
  height: 45px;
  background-color: #f1b44c;
  text-indent: -9999px;
  display: none;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  border-radius: 60px;
}

#scroll span {
  position: absolute;
  top: 48%;
  left: 50%;
  margin-left: -8px;
  margin-top: -12px;
  height: 0;
  width: 0;
  border: 8px solid transparent;
  border-bottom-color: #ffffff;
}

#scroll:hover {
  background-color: #e6ad4a;
  opacity: 1;
  filter: "alpha(opacity=100)";
  -ms-filter: "alpha(opacity=100)";
}
</style>
